import React, {useEffect, useState} from "react";
import {Button, Stack, TextField, Typography} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import EditIcon from "@mui/icons-material/Edit";
import CancelIcon from "@mui/icons-material/Cancel";

const UserNamePane = (props) => {

    const [editMode, setEditMode] = useState(false);

    const [username, setUsername] = useState("");

    useEffect(() => {

    }, []);

    function onEdit()
    {
        setEditMode(true);
    }

    function onCancel()
    {
        setEditMode(false);
    }

    function onSave()
    {

    }


    return (
        <Stack direction="column" spacing={1} padding={1} width="100%"
               alignItems="flex-start" justifyContent="flex-start"
               sx={{ backgroundColor: '#0a0a0a', borderRadius: 2}}>
            <Stack direction="row" width="100%"
                   justifyContent="space-between"
                   padding={1} spacing={1}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <img src="/icons/user.png" width={32} height={32}/>
                    <Typography variant="h6">Username</Typography>
                </Stack>
                <Stack direction="row" spacing={1}>
                    {
                        editMode === false ?
                            <Button onClick={onEdit} startIcon={<EditIcon />}>Edit</Button> :
                            <Stack direction="row">
                                <Button onClick={onCancel} startIcon={<CancelIcon />}>Cancel</Button>
                                <Button onClick={onSave} startIcon={<SaveIcon />}>Save</Button>
                            </Stack>
                    }
                </Stack>
            </Stack>
            <Stack direction="column" spacing={1} width="100%">
                <Stack direction="column" spacing={1} width="100%" alignItems="flex-start">
                    <Typography minWidth={120}>Username: {username}</Typography>
                    {
                        editMode === false ?
                            <Typography>{username}</Typography> :
                            <Stack direction="row" spacing={1} alignItems="center">
                                <Typography minWidth={120}>New Username: {username}</Typography>
                                <TextField fullWidth={true} size="small" value={username} type="text" disabled onChange={(event) => { setUsername(event.target.value); }} />
                            </Stack>
                    }
                </Stack>
            </Stack>
        </Stack>
);
}

export default UserNamePane;
